import { Injectable } from "@angular/core";
import { deepCopy, DwAction, DwActionHandler, DwActionResult, DwActionType, DwMdFormActionState, DwMdFormContextInfo, DwModalButtonStandardConfigs, DwModalConfig, DwModalResult, DwModalService, DwModalSize, DwRoutingService } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { ApplicantAcsWrittenResultEntity, AppMetaData, AppMetaDataItemNames, CheckRideRequestEntity, CheckRideRequestStatusAllItems, CheckRideRequestSubStatusAllItems, PlanOfActionDetailsQueryEntity, PlanOfActionEntity, PlanOfActionSectionEntity, PlanOfActionSectionTypeAllItems, PlanOfActionStatusAllItems } from "../../../meta-data/app-meta-data.service";
import { PlanOfActionRepositoryService } from "../services/plan-of-action-repository.service";
import { GenerateSectionsModalComponent } from "../components/generate-sections-modal/generate-sections-modal.component";
import { map, mergeMap, tap } from "rxjs/operators";
import { PlanOfActionGeneratorService } from "../services/plan-of-action-generator.service";
import { GenerateQuestionsModalComponent } from "../components/generate-questions-modal/generate-questions-modal.component";
import { AcsCodeSelectionModalOptions, AcsCodeSelectionModalResult } from "../models/acs-code-selection-modal-options.model";
import { AcsCodeStatuses } from "../models/acs-code-items.model";

@DwAction({
    keyName: 'poa-complete-checkride-action',
    display: 'Complete Plan of Action Checkride',
    actionType: DwActionType.formAction,
    isGlobal: false,
    parentItemName: [AppMetaDataItemNames.PlanOfAction],
    allowOnce: true,
    defaultButtonConfig: {
        useButtonDefaults: false,
        useParentDisplay: false,
        buttonText: 'Complete Checkride',
        buttonClass: 'btn btn-success mr-1 mt-1',
        iconClass: 'fa fa-save'
    },
    configData: {
        requireValidation: true,
        redirectAfter: true,
        actionMessage: 'Saving...',
    }
})
@Injectable()
export class POACompleteCheckrideActionService implements DwActionHandler {

    constructor(private dwRoutingService: DwRoutingService, private poaRepository: PlanOfActionRepositoryService, private dwModalService: DwModalService) { }

    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {
        const variables: { RemoveAllQuestions: boolean } = actionState.formApi.getVariableContextValue();
        const planOfAction = deepCopy(actionState.formApi.getFormData<PlanOfActionEntity>());

        const checkRide = deepCopy(planOfAction.CheckRideRequest);

        planOfAction.PlanOfActionStatusId = PlanOfActionStatusAllItems.Complete;


        let ob = of(null);

        if (variables.RemoveAllQuestions) {
            ob = this.removeAllQuestions(planOfAction);
        }

        return ob.pipe(mergeMap(() => {
            return this.updateFormAndSavePOA(actionState, planOfAction, checkRide);
        }));
    }

    private clearOutCheckrideFromPOA(planOfAction: PlanOfActionEntity): void {
        // Make so it doesn't save
        planOfAction.CheckRideRequest = AppMetaData.CheckRideRequest.CreateEntity();
        planOfAction.CheckRideRequest._isDeleted = true;
        planOfAction.CheckRideRequest.CheckRideRequestId = null;

        if (planOfAction.CheckRideRequest?.CheckRideRequestId) {
            planOfAction.CheckRideRequest.CheckRideResult.CheckRideDateTime = planOfAction.PlanOfActionResult.CheckRideStartDateTime;
        } else {
            // Don't save the checkride request if it doesn't exist
            planOfAction.CheckRideRequest._isDeleted = true;
        }
    }

    private updateFormAndSavePOA(actionState: DwMdFormActionState, planOfAction: PlanOfActionEntity, checkRide: CheckRideRequestEntity): Observable<DwActionResult> {
        actionState.formApi.patchContextData(DwMdFormContextInfo.DATA_CONTEXT_NAME, planOfAction);
        actionState.formApi.formGroup.patchValue(planOfAction);
        actionState.formApi.setFormData(planOfAction);

        return actionState.formApi.saveData(true)
            .pipe(mergeMap(saveResult => {

                if (saveResult.cancelled == true || saveResult.success == false) {
                    return of(saveResult);
                }

                return this.showConfirmationModal(saveResult.saveResult)
                    .pipe(map(modalResult => {

                        this.redirectToPlansOfActionGrid();
                        saveResult.rediectAfterOverride = false;

                        return saveResult;
                    }));
            }));
    }

    redirectToPlansOfActionGrid() {
        const url = `/plan-of-action/plans`;

        this.dwRoutingService.navigateToUrl(url, null);
    }


    private showConfirmationModal(planOfAction: PlanOfActionEntity): Observable<DwModalResult<any>> {
        let mesasge = `The Plan of Action has been marked as Complete.`;

        if (planOfAction.CheckRideRequestId) {
            mesasge+= `The Plan of Action and the associated Checkride has been marked as Complete.`;
        }

        return this.dwModalService.showDialog('Plan of Action Completed', mesasge, [DwModalButtonStandardConfigs.instance.okButton]);
    }

    // completeCheckRide(checkRide: CheckRideRequestEntity): Observable<any> {
    //     const checkrideToSave = AppMetaData.CheckRideRequest.CreateEntity();

    //     checkrideToSave.CheckRideRequestId = checkRide.CheckRideRequestId;
    //     checkrideToSave.CheckRideResult = checkRide.CheckRideResult;
    //     checkrideToSave.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.Completed;

    //     return this.poaRepository.saveCheckRideRequest(checkrideToSave);
    // }

    removeAllQuestions(planOfAction: PlanOfActionEntity): Observable<any> {

        return this.poaRepository.loadPlanOfActionQuestionResults(planOfAction.PlanOfActionResult.PlanOfActionResultId)
            .pipe(tap(questionResults => {

                planOfAction.PlanOfActionResult.PlanOfActionQuestionResult = questionResults;
                for (const questionResult of planOfAction.PlanOfActionResult.PlanOfActionQuestionResult) {
                    questionResult._isDeleted = true;
                }

                for (let section of planOfAction.PlanOfActionSection) {
                    // In the future, we might leave the manual sections
                    // if (section.PlanOfActionSectionTypeId == PlanOfActionSectionTypeAllItems.Manual) {
                    //     continue;
                    // }

                    section._isDeleted = true;

                    for (let question of section.PlanOfActionSectionQuestion) {
                        question._isDeleted = true;
                    }
                }
            }));



        //  const questionResults = this.poaRepository.loadPlanOfActionQuestionResults(planOfAction.PlanOfActionResult.PlanOfActionResultId);

        // planOfAction.PlanOfActionResult.PlanOfActionQuestionResult = questionResults;
        // for(const questionResult of planOfAction.PlanOfActionResult.PlanOfActionQuestionResult) {
        //     questionResult._isDeleted = true;
        // }

        // for(let section of planOfAction.PlanOfActionSection) {
        //     section._isDeleted = true;

        //     for(let question of section.PlanOfActionSectionQuestion) {
        //         question._isDeleted = true;
        //     }
        // }
    }

    redirectToExecute(planOfAction: PlanOfActionEntity): void {
        const url = `/plan-of-action/plans/edit/${planOfAction.PlanOfActionId}/execute`;

        this.dwRoutingService.navigateToUrl(url, null);
    }

}